export default "__VITE_ASSET__a801ff3d__"